export const ENGAGEMENT_SCOPE_QUERY_KEY = "engagement-scope";
export const ENGAGEMENT_PERIOD_QUERY_KEY = "engagement-period";
export const ENGAGEMENT_SEGMENT_QUERY_KEY = "engagement-segment";
